const TEXT_PROPS = {
  fontWeight: "normal",
  fontVariant: "normal",
  fontStyle: "normal",
  padding: "0px"
};
const STROKE_SIZES = {
  s: 1,
  m: 1.75,
  l: 2.5,
  xl: 5
};
const FONT_SIZES = {
  s: 1.125,
  m: 1.5,
  l: 2.25,
  xl: 2.75
};
const LABEL_FONT_SIZES = {
  s: 1.125,
  m: 1.375,
  l: 1.625,
  xl: 2
};
const ARROW_LABEL_FONT_SIZES = {
  s: 1.125,
  m: 1.25,
  l: 1.5,
  xl: 1.75
};
const FONT_FAMILIES = {
  draw: "var(--tl-font-draw)",
  sans: "var(--tl-font-sans)",
  serif: "var(--tl-font-serif)",
  mono: "var(--tl-font-mono)"
};
function getFontFamily(theme, font) {
  const themeFont = theme.fonts[font];
  if (themeFont) return themeFont.fontFamily;
  return FONT_FAMILIES[font] ?? font;
}
const LABEL_TO_ARROW_PADDING = 20;
const ARROW_LABEL_PADDING = 4.25;
const LABEL_PADDING = 16;
export {
  ARROW_LABEL_FONT_SIZES,
  ARROW_LABEL_PADDING,
  FONT_FAMILIES,
  FONT_SIZES,
  LABEL_FONT_SIZES,
  LABEL_PADDING,
  LABEL_TO_ARROW_PADDING,
  STROKE_SIZES,
  TEXT_PROPS,
  getFontFamily
};
//# sourceMappingURL=default-shape-constants.mjs.map
